import { CampaignSearchForm } from './CampaignSearchForm'
import { withCampaignSearchForm } from './withCampaignSearchForm'

const ConnectedCampaignSearchForm = withCampaignSearchForm(CampaignSearchForm)

export { ConnectedCampaignSearchForm as CampaignSearchForm }
